import React, { useState } from "react";
import { Card, TextContainer, Icon } from "@shopify/polaris";

import {
  MarkFulfilledMinor,
  AppExtensionMinor,
  PaymentsMajor,
  OrdersMajor,
  TapChipMajor,
  AlertMinor,
} from "@shopify/polaris-icons";
import { Row, Col } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import config from "../../config/config";
import { actFetchFilter } from "../../actions/index";
import { useHistory } from "react-router-dom";
import IndicatorFilter from "./IndicatorFilter";
import QuickHelp from "../Settings/QuickHelp";

const Analysis = () => {
  const dataStatistical = useSelector((state) => state.dataStatistical);
  const dataSettings = useSelector((state) => state.dataSettings);
  const dispatch = useDispatch();
  const history = useHistory();
  const path = config.pathName + "/orders?" + config.urlParamsValue;
  const [sheetActive, setSheetActive] = useState(false);

  const handleIndicatorFilter = (filter) => {
    dispatch(actFetchFilter(filter));
    history.push(path);
  };

  const handleQuickHelp = () => {
    setSheetActive(true);
  };

  return (
    <div>
      <Row className="statistical-layout-row">
        <Col className="mt-2" xs="12" sm="12" md="6" lg="6" xl="3">
          <Card sectioned>
            <div className="statistical-layout text-center">
              <div
                className="statistical-layout-icon"
                style={{
                  backgroundColor: "#aee9d1",
                  margin: "auto",
                  borderRadius: "50%",
                }}
              >
                <Icon color="white" source={OrdersMajor} />
              </div>
              <div className="statistical-layout-text">
                <TextContainer>
                  <b
                    className="title mt-5"
                    onClick={() =>
                      handleIndicatorFilter({
                        payment: "all",
                        status: "all",
                        type: "filter",
                      })
                    }
                  >
                    Total Fulfilled Orders
                  </b>
                  <p className="value">{dataStatistical.all_order_fulfilled}</p>
                </TextContainer>
              </div>
            </div>
          </Card>
        </Col>
        <Col className="mt-2" xs="12" sm="12" md="6" lg="6" xl="3">
          <Card sectioned>
            <div className="statistical-layout text-center">
              <div
                className="statistical-layout-icon"
                style={{
                  backgroundColor: "#aee9d1",
                  margin: "auto",
                  borderRadius: "50%",
                }}
              >
                <Icon color="white" source={MarkFulfilledMinor} />
              </div>
              <div className="statistical-layout-text">
                <TextContainer>
                  <b
                    className="title mt-5"
                    onClick={() =>
                      handleIndicatorFilter({
                        payment: "all",
                        status: "1",
                        type: "filter",
                      })
                    }
                  >
                    {" "}
                    Total Synced Orders
                  </b>
                  <p className="value">{dataStatistical.order_submitted}</p>
                </TextContainer>
              </div>
            </div>
          </Card>
        </Col>
        <Col className="mt-2" xs="12" sm="12" md="6" lg="6" xl="3">
          <Card sectioned>
            <div className="statistical-layout text-center">
              <div
                className="statistical-layout-icon"
                style={{
                  backgroundColor: "#aee9d1",
                  margin: "auto",
                  borderRadius: "50%",
                }}
              >
                <Icon color="white" source={TapChipMajor} />
              </div>
              <div className="statistical-layout-text">
                <TextContainer className>
                  <b
                    className="title"
                    onClick={() =>
                      handleIndicatorFilter({
                        payment: "all",
                        status: "total_err",
                        type: "filter",
                      })
                    }
                  >
                    Total Sync Error
                  </b>
                  <p className="value">{dataStatistical.total_err}</p>
                </TextContainer>
              </div>
              {config.platform !== "WOO_COMMERCE" &&
              dataStatistical.total_err > 0 ? (
                <div
                  className="quick-help-button"
                  style={{
                    position: "absolute",
                    right: "3rem",
                    bottom: "2rem",
                    cursor: "pointer",
                  }}
                  onClick={() => handleQuickHelp()}
                >
                  <div>
                    <Icon source={AlertMinor} color="critical" />
                    <small
                      style={{ textDecoration: "underline", opacity: "0.7" }}
                    >
                      Quick help!
                    </small>
                  </div>
                </div>
              ) : null}
            </div>
          </Card>
        </Col>
        <Col className="mt-2" xs="12" sm="12" md="6" lg="6" xl="3">
          <Card sectioned>
            <div className="statistical-layout text-center">
              <div
                className="statistical-layout-icon"
                style={{
                  backgroundColor: "#aee9d1",
                  margin: "auto",
                  borderRadius: "50%",
                }}
              >
                <Icon color="white" source={TapChipMajor} />
              </div>
              <div className="statistical-layout-text">
                <TextContainer className>
                  <b
                    className="title"
                    onClick={() =>
                      handleIndicatorFilter({
                        payment: "other",
                        status: "all",
                        type: "filter",
                      })
                    }
                  >
                    Other gateways orders
                  </b>
                  <p className="value">{dataStatistical.order_paid_by_other}</p>
                </TextContainer>
              </div>
            </div>
          </Card>
        </Col>
      </Row>
      {dataSettings.sync_stripe == "1" ? <IndicatorFilter /> : null}
      <QuickHelp
        openSheet={sheetActive}
        closeSheet={() => setSheetActive(false)}
      />
    </div>
  );
};

export default Analysis;
